import {h} from 'preact';

type TableTitlesProps = {
  firstColTitle: string;
  secondColTitle: string;
}

function TableTitles({firstColTitle, secondColTitle}: TableTitlesProps) {
  return (
    <>
      <div className="kits__table-titles">
        <div className="kits__table-titles-title wide">{firstColTitle}</div>
        <div className="kits__table-titles-title ">{secondColTitle}</div>
        <div className="kits__table-titles-title "></div>
      </div>
    </>
  )
}

export {TableTitles};


